import { useState } from 'react'
import { useLocation } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import Banner from 'components/Banner'
import Navbar from 'components/Layout/Navbar'
import Sidebar from 'components/Layout/Sidebar'
import TopNavbar from 'components/Layout/TopNavbar'

import { getBannerIsOpen } from 'store/AppState/selector'
import { setBannerIsOpen } from 'store/AppState/actions'

const Main = ({
  navbarContent,
  mainContent,
  isSidebar,
  bannerSettings,
}) => {
  const [sidebarActive, setSideBarActive] = useState(false)

  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const isBannerOpen = useSelector((state) =>
    getBannerIsOpen(state, pathname.replace('/', ''))
  )

  const toggleSidebarActive = () => {
    setSideBarActive(!sidebarActive)
  }

  const handleCloseBanner = () => {
    // when we want to close banner we have to set value on true
    dispatch(setBannerIsOpen(true, pathname.replace('/', '')))
  }

  return (
    <>
      {isBannerOpen && (
        <Banner
          text={bannerSettings?.text ?? ''}
          linkText={bannerSettings?.linkText ?? ''}
          onClose={handleCloseBanner}
        />
      )}
      <TopNavbar
        toggleSidebarActive={toggleSidebarActive}
        isBanner={isBannerOpen}
      />
      <Navbar isBanner={isBannerOpen}>{navbarContent}</Navbar>
      {isSidebar && (
        <Sidebar
          isOpen={sidebarActive}
          toggleSidebarActive={toggleSidebarActive}
          isBanner={isBannerOpen}
        />
      )}
      <main className="layout">{mainContent}</main>
    </>
  )
}

Main.defaultProps = {
  isSidebar: true,
}

Main.propTypes = {
  navbarContent: PropTypes.node,
  mainContent: PropTypes.node,
  isSidebar: PropTypes.bool,
  bannerSettings: PropTypes.object,
}

export default Main
